// extracted by mini-css-extract-plugin
export default {"input":"D8-z","button":"E8-z","selected":"F8-z","unavailable":"G8-z","oos":"H8-z","image":"I8-z","paperCutDisabledOverlay":"J8-z"};